"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getHighestQualityVideoUrl = function getHighestQualityVideoUrl() {
  var videoFiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!videoFiles || !videoFiles.length) {
    return null;
  }

  var bestFile = void 0;
  videoFiles.forEach(function (file) {
    if (!bestFile || file.quality > bestFile.quality) {
      bestFile = file;
    }
  });

  return bestFile && bestFile.url;
};

exports.default = getHighestQualityVideoUrl;